import authSelectors from 'store/selectors/auth'
import poolActions from 'store/modules/pool'

import {
  ROUTE_LOGGED_IN,
  ROUTE_LOGGED_OUT,
} from 'settings'

const auth = {
  home: store => authSelectors.data(store.getState()) ? ROUTE_LOGGED_IN : null,
  user: store => authSelectors.data(store.getState()) ? null : ROUTE_LOGGED_OUT,
  guest: store => authSelectors.data(store.getState()) ? ROUTE_LOGGED_IN : null,
}

const routes = [
  {
    name: 'home',
    path: '/',
    auth: auth.home,
  },
  {
    name: 'trynow',
    path: '/try-now',
  },
  {
    name: 'pricing',
    path: '/pricing',
  },
  {
    name: 'contact',
    path: '/contact',
  },
  {
    name: 'help',
    path: '/help',
  },
  {
    name: 'notfound',
    path: '/notfound',
  },
  {
    name: 'login',
    path: '/login',
    auth: auth.guest,
  },
  {
    name: 'logout',
    path: '/logout',
  },
  {
    name: 'settings',
    path: '/settings',
    auth: auth.user,
  },
  {
    name: 'secrets',
    path: '/secrets',
    auth: auth.user,
  },
  {
    name: 'payment',
    path: '/payment',
    auth: auth.user,
  },
  {
    name: 'access_token',
    path: '/access_token',
    auth: auth.user,
  },
  {
    name: 'launch',
    path: '/launch',
    auth: auth.user,
  },
  {
    name: 'pools',
    path: '/pools',
    auth: auth.user,
    trigger: async (store, params) => {
      await store.dispatch(poolActions.load())
    },
  },
  {
    name: 'pool_logs',
    path: '/pools/:id/logs',
    auth: auth.user,
  },
  {
    name: 'vm_logs',
    path: '/pools/:pool_id/vms/:vm_uuid/logs/:lease_id',
    auth: auth.user,
  },
]


export default routes
